var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.01,
    height: 16,
    viewBox: "0 0 17.01 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pie-chart",
    d: "M16.531-5a.489.489,0,0,1,.375.172.46.46,0,0,1,.125.391A7.376,7.376,0,0,1,14.75-.031a.443.443,0,0,1-.687-.031L9.094-5Zm-.5-2.031a.541.541,0,0,1-.141.375.462.462,0,0,1-.359.156h-7v-7a.462.462,0,0,1,.156-.359A.541.541,0,0,1,9.063-14a7.252,7.252,0,0,1,4.781,2.188A7.252,7.252,0,0,1,16.031-7.031ZM7.031-5,11.906-.125a.481.481,0,0,1,.141.391.444.444,0,0,1-.2.359A7.24,7.24,0,0,1,7.625,2,7.261,7.261,0,0,1,2.375-.109,7.173,7.173,0,0,1,.031-5.25,7.255,7.255,0,0,1,1.8-10.328a7.165,7.165,0,0,1,4.672-2.578.484.484,0,0,1,.391.109.477.477,0,0,1,.172.391Z",
    transform: "translate(-0.027 14)",
    fill: "#0a0a0a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.7244ed98dd6ae2465c2f0f7d92e55ea0.svg";
export { ForwardRef as ReactComponent };